import ColorSelectWidget from '../CTASection/ColorSelectWidget';
import messages from '../../../../messages';

const EditSchema = (props) => ({
  title: 'FCMH: Statistics',
  fieldsets: [
    {
      id: 'default',
      title: props.intl.formatMessage(messages.statisticsSettings),
      fields: [
        'title',
        'columns',
        'align',
        'color',
        'showAnimation',
        'stats',
        'full_width',
      ],
    },
  ],
  properties: {
    title: {
      title: 'Titel',
      type: 'string',
    },
    columns: {
      title: props.intl.formatMessage(messages.statisticsColumns),
      type: 'string',
      factory: 'Choice',
      choices: [
        ['two', '2'],
        ['three', '3'],
        ['four', '4'],
      ],
      default: 'four',
    },
    align: {
      title: props.intl.formatMessage(messages.statisticsAlignment),
      type: 'string',
      factory: 'Choice',
      choices: [
        ['left', props.intl.formatMessage(messages.statisticsAlignmentLeft)],
        [
          'center',
          props.intl.formatMessage(messages.statisticsAlignmentCenter),
        ],
        ['right', props.intl.formatMessage(messages.statisticsAlignmentRight)],
      ],
      default: 'left',
    },
    color: {
      title: props.intl.formatMessage(messages.statisticsBackgroundColor),
      widget: ColorSelectWidget,
      default: 'blue',
    },
    full_width: {
      title: props.intl.formatMessage(messages.fullWidth),
      type: 'boolean',
      default: false,
    },
    showAnimation: {
      title: props.intl.formatMessage(messages.statisticsAnimation),
      type: 'boolean',
      default: true,
    },
    stats: {
      title: props.intl.formatMessage(messages.statisticsAnimation),
      widget: 'object_list',
      schema: {
        fieldsets: [
          {
            id: 'default',
            title: props.intl.formatMessage(messages.statisticsElement),
            fields: ['value', 'label', 'info'],
          },
        ],
        properties: {
          value: {
            title: props.intl.formatMessage(messages.statisticsElementValue),
            type: 'string',
          },
          label: {
            title: 'Label',
            type: 'string',
          },
          info: {
            title: props.intl.formatMessage(messages.statisticsElementInfo),
            type: 'string',
          },
        },
      },
    },
  },
  required: [],
});

export default EditSchema;
